module.exports = "<app-project-template [Projects]=\"tinkeringProjects\">\n</app-project-template>\n"